import { Injectable } from '@angular/core';
import { Apollo, MutationResult } from 'apollo-angular';
import { Observable } from 'rxjs';

import { IGQLSingleResponse } from '../../interfaces/graphql.interface';
import { ITwoFactorAuthenticationSecret } from '../../interfaces/settings/settings.interface';
import {
  addTwoFactorAuthentication,
  createThirdPartyCookie,
  getTwoFactorAuthenticationSecret,
  isTwoFactorAuthenticationEnabled,
  removeTwoFactorAuthentication,
  verifyTwoFactorAuthenticationCode,
} from './settings.graphql';

@Injectable({ providedIn: 'root' })
export class SettingsGQLService {
  constructor(private apollo: Apollo) {}

  createThirdPartyCookie(
    user: string,
    issuer: string,
  ): Observable<MutationResult<IGQLSingleResponse<string>>> {
    return this.apollo.mutate<IGQLSingleResponse<string>>({
      mutation: createThirdPartyCookie,
      variables: {
        input: {
          user,
          issuer,
        },
      },
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    });
  }

  removeTwoFactorAuthentication(): Observable<
    MutationResult<IGQLSingleResponse<boolean>>
  > {
    return this.apollo.mutate<IGQLSingleResponse<boolean>>({
      mutation: removeTwoFactorAuthentication,
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    });
  }

  isTwoFactorAuthenticationEnabled(): Observable<
    MutationResult<IGQLSingleResponse<boolean>>
  > {
    return this.apollo.mutate<IGQLSingleResponse<boolean>>({
      mutation: isTwoFactorAuthenticationEnabled,
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    });
  }

  getSecret(): Observable<
    MutationResult<IGQLSingleResponse<ITwoFactorAuthenticationSecret>>
  > {
    return this.apollo.mutate<
      IGQLSingleResponse<ITwoFactorAuthenticationSecret>
    >({
      mutation: getTwoFactorAuthenticationSecret,
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    });
  }

  addTwoFactorAuthentication(
    secret: string,
  ): Observable<MutationResult<IGQLSingleResponse<boolean>>> {
    return this.apollo.mutate<IGQLSingleResponse<boolean>>({
      mutation: addTwoFactorAuthentication,
      variables: {
        input: {
          secret,
        },
      },
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    });
  }

  verifyTwoFactorAuthenticationCode(
    code: string,
    secret: string,
  ): Observable<MutationResult<IGQLSingleResponse<boolean>>> {
    return this.apollo.mutate<IGQLSingleResponse<boolean>>({
      mutation: verifyTwoFactorAuthenticationCode,
      variables: {
        input: {
          code,
          secret,
        },
      },
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    });
  }
}
